import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabRoutesService {
  private tabRoutes = new BehaviorSubject(
    [] as { title: string; link: string; premission?: string; activeStateLinks?: string[] }[]
  );

  tabRotues$ = this.tabRoutes.asObservable();

  updateList(newList: { title: string; link: string; premission?: string; activeStateLinks?: string[] }[]) {
    this.tabRoutes.next(newList);
  }
  //Accounts Module
  //Account Category
  accountCategory: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'ACCOUNTCATE.GENERAL.ADD_ACCOUNTCATE',
        link: 'create-or-update-account-category',
      },
      {
        title: 'ACCOUNTCATE.GENERAL.VIEW_ACCOUNTCATE',
        link: 'list-account-category',
      },
    ];

  //Account Type
  accountType: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'ACCOUNTTYPE.GENERAL.ADD_ACCOUNTTYPE',
        link: 'create-or-update-account-type',
      },
      {
        title: 'ACCOUNTTYPE.GENERAL.VIEW_ACCOUNTTYPE',
        link: 'list-account-type',
      },
    ];

  //Journal
  journals: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'DAILYJOURNAL.GENERAL.ADD_JOURNAL',
        link: 'create-or-update-journal',
      },
      {
        title: 'DAILYJOURNAL.GENERAL.VIEW_JOURNAL',
        link: 'list-journals',
      },
    ];

  //Account Statements
  account_statements: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'ACCOUNTSTAT.GENERAL.VIEW_ACCOUNTSTAT',
        link: 'list-account-statements',
      },
    ];
  //Financial Statements
  financial_statements: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'FINANCIALSTAT.GENERAL.ADD_FINANCIALSTAT',
        link: 'create-or-update-financial-statement',
      },
      {
        title: 'FINANCIALSTAT.GENERAL.VIEW_FINANCIALSTAT',
        link: 'list-financial-statement',
      },
    ];

  branches: { title: string; link: string }[] = [
    {
      title: 'BRANCHES.BTN.CREATE',
      link: 'branch/branch',
    },
    {
      title: 'BRANCHES.GENERAL.VIEW_BRANCHES',
      link: 'branch/branches-list',
    },
  ];

  //Journal Type
  journalType: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'JOURNALTYPE.GENERAL.ADD_JOURNALTYPE',
        link: 'create-or-update-journal-type',
      },
      {
        title: 'JOURNALTYPE.GENERAL.VIEW_JOURNALTYPE',
        link: 'list-journal-type',
      },
    ];

  //TAX RETURN 
  taxReturn: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'TAXRETURN.GENERAL.TITLE',
        link: 'tax-return',
      },
    ];

  salesInvoice: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'INVOICES.GENERAL.ADD_INVOICE',
        link: 'create-invoice',
      },
      {
        title: 'INVOICES.GENERAL.VIEW_INVOCES',
        link: 'invoice',
      },
    ];

  returnInvoices: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'INVOICES.GENERAL.VIEW_RETURN_INVOCES',
        link: 'return-invoices',
      },
      {
        title: 'INVOICES.GENERAL.VIEW_RETURN_INVOCE',
        link: 'view-invoice',
      },
    ];

  companies: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'COMPANIES.GENERAL.TITLE',
        link: 'companies',
      },
      {
        title: 'COMPANIES.BTN.CREATE',
        link: 'company',
      }
    ];

  currencies: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'CURRENCIES.GENERAL.TITLE',
        link: 'currencies',
      },
      {
        title: 'CURRENCIES.BTN.CREATE',
        link: 'currency',
      }
    ];

  roles: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'SIDEMENU.ROLE',
        link: 'role',
      },
      {
        title: 'ROLES.BTN.CREATE',
        link: 'roles',
      }
    ];

  customers: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'CUSTOMERS.BTN.ADDITEM',
        link: 'create-customer',
      },
      {
        title: 'CUSTOMERS.GENERAL.TITLE',
        link: 'customers-list',
      },
    ];

  vendors: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'CUSTOMERS.BTN.ADDVENDOR',
        link: 'create-vendor',
      },
      {
        title: 'CUSTOMERS.GENERAL.TITLE_VENDOR',
        link: 'vendors-list',
      },
    ];

  //Products Routing Tab
  products: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'PRODUCTS.GENERAL.TITLE',
        link: 'list-products',
      },
      {
        title: 'PRODUCTS.GENERAL.CREATE_PRODUCT',
        link: 'create-or-update-product',
      },

      // {
      //   title: 'SIDEMENU.PRODUCT_CATE',
      //   link: 'list-categories',
      // },
      // {
      //   title: 'UNITS_OF_MEASUREMENT.GENERAL.TITLE',
      //   link: 'list-units',
      // },
      // {
      //   title: 'BARCODE.GENERAL.TITLE',
      //   link: 'list-barcode',
      // },
    ];

  //Product Category Routing Tab
  productCategory: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'PRODUCTCATE.BTN.ADDITEM',
        link: 'create-update-product-category',
      },
      {
        title: 'SIDEMENU.PRODUCT_CATE',
        link: 'list-product-category',
      },
    ];
  //Stors Tab
  stores: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'STORE.GENERAL.ADD_STORE',
        link: 'create-update-store',
      },
      {
        title: 'STORE.GENERAL.VIEW_STORES',
        link: 'list-store',
      },
    ];

  users: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'USERS.GENERAL.ADD_USER',
        link: 'create-user',
      },
      {
        title: 'USERS.GENERAL.TITLE',
        link: 'users-list',
      },
    ];

  units: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'UNITS.BTN.ADDITEM',
        link: 'create-update-unit',
      },
      {
        title: 'UNITS.GENERAL.TITLE',
        link: 'list-product-units',
      },
    ];

  prices: {
    title: string;
    link: string;
  }[] = [
      {
        title: 'PRICES.BTNS.ADDITEM',
        link: 'create-update-price',
      },
      {
        title: 'PRICES.GENERAL.TITLE',
        link: 'list-prices',
      },
    ];

  constructor() { }
}
